import React, {useContext} from 'react';
import {GlobalContext} from '../../utilities/GlobalContext';

function NavStyles() {
	//#region Params
	let currentLocation = useContext(GlobalContext).getCurrentLocation;
	let minimumMarginX = useContext(GlobalContext).minimumMargin;
	let isMobile = useContext(GlobalContext).isMobile;
	//#endregion

	//#region Style vars
	let display = 'flex';
	let contactMeContainerDisplay = 'flex';
	//#endregion

	//#region seting vars based off params
	if (currentLocation() === 'index') {
		display = 'none';
		contactMeContainerDisplay = 'none';
	}
	if (currentLocation() === 'support') {
		contactMeContainerDisplay = 'none';
	}
	//#endregion

	return {
		outerStyle: ({mt} = {}) => {
			return {
				display: display,
				marginTop: mt ? '3rem' : 'unset',
				flexWrap: 'wrap',
				padding: `0 ${minimumMarginX}rem 1rem ${minimumMarginX}rem`,
				backgroundColor: `#262626`,
			};
		},
		colStyle: () => {
			return {
				display: 'flex',
				flexDirection: 'column',
			};
		},
		colClasses: ({i} = {}) => {
			let isLeft = i % 2 === 0;
			let classes = `col-6 col-sm-3 ${isLeft ? 'pe-2' : 'ps-2'}`;
			return classes;
		},
		textStyle: ({text} = {}) => {
			let fontSize = shouldTextBeSmall(text, isMobile) ? '0.75rem' : '1rem';
			return {
				marginTop: '1rem',
				color: 'white',
				textDecoration: 'none',
				textOverflow: 'ellipsis',
				display: 'inline-block',
				fontSize: fontSize,
			};
		},
		contactMeContainer: () => {
			return {
				display: contactMeContainerDisplay,
			};
		},
	};
}

function shouldTextBeSmall(text) {
	let chunks = text.split(' ');

	for (let i = 0; i < chunks.length; i++) {
		let currentText = chunks[i];
		if (currentText.length > 15) {
			return true;
		}
	}

	return false;
}

export default NavStyles;
